<div class="app-container">
    @if(environmentName === 'UAT'){
        <avenir-top-header></avenir-top-header>
    }
    @if(displayComponent) {
        <avenir-header [clientId]="clientId"></avenir-header>
    }
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    @if(displayComponent) {
        <avenir-footer></avenir-footer>
    }
</div>

<avenir-loader></avenir-loader>
<avenir-toast></avenir-toast>